export default "__VITE_ASSET__DsMoGubj__"